module.exports = __webpack_public_path__ + "static/media/ips-accounts.9e84f375.svg";